export enum Roles {
  PROFESSIONAL = "PROFESSIONAL",
  CUSTOMER = "CUSTOMER",
}
